// =====================================================
// COMPANY CONFIGURATION
// Edit this file to customize ProEstiMate for your company
// =====================================================

export const COMPANY = {
  // Company Name (appears on estimates)
  name: "Your Company Name",
  
  // License Number
  license: "CGC1234567",
  
  // Tagline (appears under company name)
  tagline: "Licensed General Contractor",
  
  // Address
  address: "123 Main Street",
  city: "Naples",
  state: "FL",
  zip: "34120",
  
  // Contact Information
  phone: "555-123-4567",
  email: "info@yourcompany.com",
  website: "www.yourcompany.com",
  
  // Default Tax Rate (%)
  defaultTaxRate: 7.0,
  
  // Logo (place your logo in public/logo.png)
  // Set to null to use text-based logo
  logoUrl: null,
  
  // Primary Brand Color (hex)
  primaryColor: "#D97706", // Amber
  
  // Secondary Brand Color (hex)
  secondaryColor: "#1F2937", // Dark Gray
};

// Default Terms and Conditions
export const DEFAULT_TERMS = {
  en: `TERMS AND CONDITIONS

1. ESTIMATE VALIDITY: This estimate includes costs of materials and labor as of the date of this estimate. Prices are subject to change if work is not commenced within 30 days.

2. PAYMENT TERMS: A 50% deposit is required upon acceptance of this estimate. Balance due upon completion of work.

3. CANCELLATION POLICY: Cancellation within 48 hours of project start date incurs a 10% fee of total estimate.

4. CHANGE ORDERS: Any changes to scope of work must be documented in writing and may result in additional charges.

5. WARRANTY: Workmanship is warranted for one (1) year from date of completion. Material warranties per manufacturer specifications.

6. PERMITS: Unless otherwise noted, permit costs are included in this estimate.

7. INSURANCE: Contractor maintains general liability and workers' compensation insurance.

8. COMPLETION: Estimated completion times are subject to weather, material availability, and change orders.

MANDATORY DISCLOSURE – FLORIDA CONSTRUCTION LIEN LAW (§ 713.015)

ACCORDING TO FLORIDA'S CONSTRUCTION LIEN LAW (SECTIONS 713.001-713.37, FLORIDA STATUTES), THOSE WHO WORK ON YOUR PROPERTY OR PROVIDE MATERIALS AND SERVICES AND ARE NOT PAID IN FULL HAVE A RIGHT TO ENFORCE THEIR CLAIM FOR PAYMENT AGAINST YOUR PROPERTY. THIS CLAIM IS KNOWN AS A CONSTRUCTION LIEN.

IF YOUR CONTRACTOR OR A SUBCONTRACTOR FAILS TO PAY SUBCONTRACTORS, SUB-SUBCONTRACTORS, OR MATERIAL SUPPLIERS, THOSE PEOPLE WHO ARE OWED MONEY MAY LOOK TO YOUR PROPERTY FOR PAYMENT, EVEN IF YOU HAVE ALREADY PAID YOUR CONTRACTOR IN FULL.

By signing below, client acknowledges and agrees to these terms and conditions.`,
  
  es: `TÉRMINOS Y CONDICIONES

1. VALIDEZ DEL PRESUPUESTO: Este presupuesto incluye costos de materiales y mano de obra a la fecha de este presupuesto. Los precios están sujetos a cambios si el trabajo no comienza dentro de 30 días.

2. TÉRMINOS DE PAGO: Se requiere un depósito del 50% al aceptar este presupuesto. El saldo vence al finalizar el trabajo.

3. POLÍTICA DE CANCELACIÓN: La cancelación dentro de las 48 horas de la fecha de inicio del proyecto incurre en un cargo del 10% del presupuesto total.

4. ÓRDENES DE CAMBIO: Cualquier cambio en el alcance del trabajo debe documentarse por escrito y puede resultar en cargos adicionales.

5. GARANTÍA: La mano de obra está garantizada por un (1) año desde la fecha de finalización. Garantías de materiales según especificaciones del fabricante.

6. PERMISOS: A menos que se indique lo contrario, los costos de permisos están incluidos en este presupuesto.

7. SEGURO: El contratista mantiene seguro de responsabilidad general y compensación laboral.

8. FINALIZACIÓN: Los tiempos estimados de finalización están sujetos al clima, disponibilidad de materiales y órdenes de cambio.

DIVULGACIÓN OBLIGATORIA – LEY DE GRAVAMEN DE CONSTRUCCIÓN DE FLORIDA (§ 713.015)

SEGÚN LA LEY DE GRAVAMEN DE CONSTRUCCIÓN DE FLORIDA (SECCIONES 713.001-713.37, ESTATUTOS DE FLORIDA), AQUELLOS QUE TRABAJAN EN SU PROPIEDAD O PROPORCIONAN MATERIALES Y SERVICIOS Y NO SE LES PAGA EN SU TOTALIDAD TIENEN DERECHO A HACER VALER SU RECLAMO DE PAGO CONTRA SU PROPIEDAD.

Al firmar a continuación, el cliente reconoce y acepta estos términos y condiciones.`
};
